/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LivewatchOverviewInfo } from '../models/LivewatchOverviewInfo';
import type { LivewatchPlanInfo } from '../models/LivewatchPlanInfo';
import type { LivewatchRateInfo } from '../models/LivewatchRateInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LivewatchControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns LivewatchRateInfo OK
     * @throws ApiError
     */
    public getLivewatchRate({
        detectType = 'OBJECTIVE_DISTRIBUTION_PLAN',
    }: {
        detectType?: 'OBJECTIVE_RETENTION_PLAN' | 'OBJECTIVE_DISTRIBUTION_PLAN',
    }): CancelablePromise<LivewatchRateInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/livewatch/rate',
            query: {
                'detectType': detectType,
            },
        });
    }

    /**
     * @returns LivewatchPlanInfo OK
     * @throws ApiError
     */
    public getLivewatchPlan({
        detectType = 'OBJECTIVE_DISTRIBUTION_PLAN',
    }: {
        detectType?: 'OBJECTIVE_RETENTION_PLAN' | 'OBJECTIVE_DISTRIBUTION_PLAN',
    }): CancelablePromise<LivewatchPlanInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/livewatch/plan',
            query: {
                'detectType': detectType,
            },
        });
    }

    /**
     * @returns LivewatchOverviewInfo OK
     * @throws ApiError
     */
    public getLivewatchOverview(): CancelablePromise<LivewatchOverviewInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/livewatch/overview',
        });
    }

}
